export default __webpack_public_path__ + "static/media/1.b66d8526.png";